import React, { useEffect } from "react";
import { X } from "lucide-react";

export const NextSellerSourceInfoDialog = ({ open, onClose }) => {
    useEffect(() => {
        if (!open) return undefined;
        const closeOnEscape = (event) => { if (event.key === "Escape") onClose(); };
        document.addEventListener("keydown", closeOnEscape);
        return () => document.removeEventListener("keydown", closeOnEscape);
    }, [open, onClose]);

    if (!open) return null;
    return (
        <div
            data-testid="next-seller-source-info-overlay"
            role="presentation"
            className="fixed inset-0 z-[10040] bg-black/60 backdrop-blur-sm grid place-items-center p-4"
            onMouseDown={(event) => { if (event.target === event.currentTarget) onClose(); }}
        >
            <section data-testid="next-seller-source-info-dialog" role="dialog" aria-modal="true" aria-labelledby="next-seller-source-info-title" className="next-seller-dialog w-full max-w-md">
                <div className="flex items-start justify-between gap-4">
                    <h3 id="next-seller-source-info-title" className="font-serif text-xl text-ink-50">Info sulle fonti</h3>
                    <button data-testid="next-seller-source-info-close" type="button" onClick={onClose} aria-label="Chiudi informazioni sulle fonti" className="icon-btn"><X size={17} /></button>
                </div>
                <p data-testid="next-seller-source-info-text" className="mt-5 text-sm leading-6 text-ink-300">Le opportunità mostrate sono elaborate da fonti pubbliche e ufficiali (tribunali, gazzette, registri pubblici). I dati hanno valore indicativo e non costituiscono consulenza legale o finanziaria.</p>
            </section>
        </div>
    );
};